import React from 'react'
import Box from '@mui/material/Box';
import GridStructure from './GridStructure';
import { panVerificationDataList } from '../../constants/externalInformationData';

function PanVerification({ content }) {
    return (
        (content && Object?.keys(content)?.length)
            ?
            <Box>
                <GridStructure gridDataList={panVerificationDataList} content={content} tab={"panVerification"} />
            </Box>
            :
            <div
                style={{
                    margin: "20px 7px",
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "grey",
                }}
            >
                <h3>No data</h3>
            </div>
    )
}

export default PanVerification